import { User } from "./user";

export class ApprovalHierarchy {
    purchaseOrderApprovalHierarchyId: number;    
    managerADIntegrationKey: string;
    employeeADIntegrationKey: string;
    marketId: number;
    marketName: string;
    reassignPurchaseOrders: boolean;

    manager: User;
    employee: User;
}
